<script lang="ts">
    import { Drawer, Button } from "flowbite-svelte";
    import ProjectObject from "../objects/ProjectObject.svelte";
    import CustomerObject from "../objects/CustomerObject.svelte";
    import { drawerStore, closeDrawer, saveObject } from "../../services/stores/object-drawer-store.js";
    import { sineIn } from "svelte/easing";
    import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
    import { faTimes } from "@fortawesome/free-solid-svg-icons";

    let activateClickOutside = false;
    let activeDrawerInstance: any;
    let currentInstanceId: string | null = null;
    
    // Add lookup data from your store or service
    let lookupData: Record<string, any>;  // You'll need to load this

    $: title = $drawerStore.action === "add" ? `Add ${toProperCase($drawerStore.objectType ?? "")}` : `Edit ${toProperCase($drawerStore.objectType ?? "")}`;
    $: hidden = !$drawerStore.open || $drawerStore.objectType === "user";
    $: {
        if ($drawerStore.instanceId !== currentInstanceId) {
            currentInstanceId = $drawerStore.instanceId;
            if ($drawerStore.open && $drawerStore.objectType !== "user") {
                activeDrawerInstance = 
                    $drawerStore.objectType === "project" ? ProjectObject :
                    $drawerStore.objectType === "customer" ? CustomerObject :
                    null;
            } else {
                activeDrawerInstance = null;
            }
        }
    }

    let transitionParams = {
        x: -320,
        duration: 200,
        easing: sineIn,
    };

    function handleSave(event: CustomEvent) {
        saveObject(event.detail);
    }

    function handleClose() {
        closeDrawer();
    }

    function toProperCase(str: string) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
</script>

<Drawer id="generic-drawer" class="object-drawer" {activateClickOutside} transitionType="fly" {transitionParams} placement="left" backdrop={true} bind:hidden>
    <div class="drawer-header">
        <div class="drawer-title-container">
            <h2>{title}</h2>
        </div>
        <Button class="drawer-header-button" on:click={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
        </Button>
    </div>
    {#if activeDrawerInstance}
        <svelte:component
            this={activeDrawerInstance}
            {...(() => {
                switch ($drawerStore.objectType) {
                    case "project":
                        return { 
                            object: $drawerStore.object,
                            action: $drawerStore.action 
                        };
                    case "customer":
                        return { 
                            object: $drawerStore.object,
                            action: $drawerStore.action
                        };
                    case "user":
                        return { 
                            object: $drawerStore.object,
                            action: $drawerStore.action
                        };
                    default:
                        return {};
                }
            })()}
            on:save={handleSave}
            on:close={handleClose}
        />
    {/if}
</Drawer>